<template>
  <validation-observer ref="simpleRules">
    <b-row>
      <!-- Merchant -->
      <b-col
        v-if="userData.role === 'admin'"
        cols="12"
      >
        <b-form-group
          label-for="input-merchant"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.merchant.title"
              :description="labelForm.merchant.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="merchant"
            rules="required"
          >
            <v-select
              id="input-merchant"
              v-model="form.merchant"
              input-id="input-merchant"
              label="name"
              :loading="isSearchingMerchant"
              :options="dataBrand"
              :filterable="false"
              @search="onSearchMerchant"
            >
              <template #option="{ name }">
                {{ name }}
              </template>
              <!-- eslint-disable-next-line vue/no-unused-vars  -->
              <template #no-options="{ search, searching, loading }">
                <span v-if="searching">
                  "{{ search }}" tidak ditemukan.
                </span>
                <span v-else>
                  Cari Merchant...
                </span>
              </template>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Gambar Produk -->
      <b-col cols="12">
        <b-form-group
          label-for="input-image"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.image.title"
              :description="labelForm.image.description"
              required
            />
          </template>
          <div class="d-flex flex-wrap">
            <draggable-image-container
              :images="form.images"
              @drag-start="isDraggingImages = true"
              @drag-end="isDraggingImages = false"
              @reorder="swapImages"
              @setmain="onSetMainImage"
              @delete="onDeleteImage"
            >
              <template #upload>
                <form-image
                  id="input-image"
                  v-model="tmpImg"
                  :width="1080"
                  label="Upload"
                  with-endpoin
                  :multiple="$store.state.auth.userData.role === 'admin'"
                  @finish="setPhotoFile"
                />
              </template>
            </draggable-image-container>
          </div>
          <validation-provider
            #default="{ errors }"
            name="gambar"
            rules="required"
          >
            <input
              v-model="form.images"
              type="hidden"
            >
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Nama Produk -->
      <b-col cols="12">
        <b-form-group
          label-for="input-name"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.name.title"
              :description="labelForm.name.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="nama produk"
            rules="required"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              placeholder="Nama Produk"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Kategori -->
      <b-col cols="12">
        <b-form-group
          label-for="input-category"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.category.title"
              :description="labelForm.category.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="kategori"
            rules="required"
          >
            <v-select
              id="input-category"
              v-model="form.category"
              label="name"
              :options="subCategoryList"
              :state="errors.length > 0 ? false : null"
              input-id="input-category"
            >
              <template #option="{ name }">
                {{ name }}
              </template>
              <template #no-options>
                Kategori tidak ditemukan.
              </template>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Produk tersedia / tidak tersedia -->
      <b-col cols="12">
        <b-form-group
          label-for="input-available"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.available.title"
              :description="labelForm.available.description"
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="Produk Tersedia"
          >
            <b-form-checkbox
              v-model="form.is_active"
              :checked="true"
              name="check-is_active"
              switch
              inline
            >
              Tersedia
            </b-form-checkbox>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Wajib asuransi -->
      <b-col cols="12">
        <b-form-group
          label-for="input-available"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.require_delivery_insurance.title"
              :description="labelForm.require_delivery_insurance.description"
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="Asuransi pengiriman"
          >
            <div
              v-if="(form.merchant && form.merchant.address.is_pickup_jne_enabled)
                || ($store.state.auth.userData.role === 'merchant' && $store.state.auth.userData.merchant.address.is_pickup_jne_enabled)"
              class="demo-inline-spacing"
            >
              <b-form-radio
                v-model="form.require_delivery_insurance"
                class="mt-0"
                name="is_active"
                value="1"
              >
                Wajib
              </b-form-radio>
              <b-form-radio
                v-model="form.require_delivery_insurance"
                class="mt-0"
                name="is_active"
                value="0"
              >
                Opsional
              </b-form-radio>
            </div>
            <div
              v-else
              class="demo-inline-spacing"
            >
              <b-form-radio
                v-b-tooltip.hover.top="form.merchant || $store.state.auth.userData.role === 'merchant' ? `${form.merchant ? form.merchant.name : 'Merchant Anda' } belum mengaktifkan Pickup JNE` : 'Harap pilih merchant terlebih dahulu'"
                class="mt-0"
                disabled
              >
                Wajib
              </b-form-radio>
              <b-form-radio
                v-b-tooltip.hover.top="form.merchant || $store.state.auth.userData.role === 'merchant' ? `${form.merchant ? form.merchant.name : 'Merchant Anda' } belum mengaktifkan Pickup JNE` : 'Harap pilih merchant terlebih dahulu'"
                class="mt-0"
                disabled
              >
                Opsional
              </b-form-radio>
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Keyword Produk -->
      <b-col
        v-if="isEdit"
        cols="12"
      >
        <b-form-group
          label-for="input-keyword"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.keyword.title"
              :description="labelForm.keyword.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="Keyword produk"
            rules="required"
          >
            <b-form-textarea
              id="input-keyword"
              v-model="form.keyword"
              placeholder="Keyword"
              rows="3&quot;"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Deskripsi -->
      <b-col cols="12">
        <b-form-group
          label-for="input-description"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.description.title"
              :description="labelForm.description.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="deskripsi"
            rules="required"
          >
            <quill-editor
              id="input-description"
              v-model="form.description"
              class="is-invalid long-height"
              :options="options"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="userData.role === 'admin'">
      <h3 class="mt-3">
        Informasi Lainnya
      </h3>
      <hr>

      <b-row class="mt-2">
        <!-- Registry Only -->
        <b-col cols="12">
          <b-form-group
            label-for="input-available"
            label-cols-md="4"
            label-class="pt-0"
          >
            <template #label>
              <FormLabel
                :title="labelForm.is_registry_only.title"
                :description="labelForm.is_registry_only.description"
              />
            </template>
            <validation-provider
              #default="{ errors }"
              name="Produk Tersedia"
            >
              <b-form-checkbox
                v-model="form.is_registry_only"
                :checked="true"
                name="check-is_active"
                switch
                inline
              >
                Khusus Registry
              </b-form-checkbox>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </validation-observer>
</template>

<script>
import {
  BFormRadio,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BRow,
  BCol,
  BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor'

import FormImage from '@/layouts/components/custom/FormImage.vue'
import FormLabel from '@/layouts/components/custom/FormLabel.vue'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import vSelect from 'vue-select'
import { mapState, mapGetters, mapActions } from 'vuex'
import DraggableImageContainer from '@/layouts/components/custom/drag/DraggableImageContainer.vue'

export default {
  name: 'ProductInfoForm',
  components: {
    BFormRadio,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BRow,
    BCol,
    BFormCheckbox,
    vSelect,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    // form
    FormImage,
    FormLabel,
    DraggableImageContainer,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      isSearchingMerchant: false,
      tmpImg: null,
      isDraggingImages: false,
      options: {
        placeholder: 'Sepatu Sneakers Pria Tokostore Kanvas Hitam Seri C28B'
        + '\n\n- Model simple\n- Nyaman Digunakan\n- Tersedia warna hitam'
        + '\n- Sole PVC (injection shoes) yang nyaman dan awet untuk digunakan sehari\n- hari'
        + '\n\nBahan: \nUpper: Semi Leather (kulit tidak pecah-pecah) \nSole: Premium Rubber Sole'
        + '\n\nUkuran \n39 : 25,5 cm\n40 : 26 cm\n41 : 26.5 cm\n42 : 27 cm\n43 : 27.5 - 28 cm'
        + '\n\nEdisi terbatas dari Tokostore dengan model baru dan trendy untukmu.'
        + 'Didesain untuk bisa dipakai dalam berbagai acara. Sangat nyaman saat dipakai '
        + 'sehingga dapat menunjang penampilan dan kepercayaan dirimu. Beli sekarang sebelum kehabisan!',
      },
    }
  },
  computed: {
    ...mapState('brand', ['brandList']),
    ...mapState('products', ['labelForm']),
    ...mapGetters('category', ['subCategoryList']),
    dataBrand() {
      return this.brandList.data
    },
  },
  async mounted() {
    await this.getCategoryList()
  },
  methods: {
    ...mapActions('brand', ['getBrandList']),
    ...mapActions('category', ['getCategoryList']),
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
    async setPhotoFile(data) {
      const datas = await JSON.parse(JSON.stringify(data))
      this.form.imagesFile.push(datas.id)
      await this.form.images.push(datas)
      this.tmpImg = null
    },
    async onSearchMerchant(text, loading) {
      if (text.length) {
        this.isSearchingMerchant = true
        loading(true)
        await this.getBrandList({ page: 1, keyword: text })
      }

      this.isSearchingMerchant = false
    },
    onSetMainImage(index) {
      this.arrayMove(this.form.images, index, 0)
    },
    onDeleteImage(index) {
      this.form.images.splice(index, 1)
    },
    swapImages(fromIndex, toIndex) {
      this.arrayMove(this.form.images, fromIndex, toIndex)
    },
    arrayMove(arr, oldIndex, newIndex) {
      if (newIndex >= arr.length) {
        let k = newIndex - arr.length + 1
        // eslint-disable-next-line no-plusplus
        while (k--) {
          arr.push(undefined)
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
      return arr
    },
  },
}
</script>
